import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=4f3b86da&scoped=true"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsDialog.vue?vue&type=style&index=0&id=4f3b86da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3b86da",
  null
  
)

export default component.exports